var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_103_2188",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_103_2188)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_103_2188",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 3,
    height: 3,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 3,
    height: 3,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-2-inside-2_103_2188)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_103_2188",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 3,
    height: 3,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 3,
    height: 3,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-3-inside-3_103_2188)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_103_2188",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 3,
    height: 3,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 3,
    height: 3,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-4-inside-4_103_2188)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.5H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicList);
export default __webpack_public_path__ + "static/media/dynamic_list.ce73f9ee190344467d5021b06960a34a.svg";
export { ForwardRef as ReactComponent };